<template lang="pug">
  b-modal#addRole(
  ref="addRole"
  :title="$t('ui.combine.add_role')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')")
        DebounceInput(
          size="sm"
          ref="dataAdd_roleId"
          required
          alphaNum
          type="text"
          :dirty="$v.dataAdd_roleId.$dirty"
          :error="$v.dataAdd_roleId.$error"
          v-model.trim.lazy="$v.dataAdd_roleId.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_roleId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_roleId" :name="$t('ui.id')")
      b-form-group(:label="$t('ui.name')")
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_roleName.$dirty"
          :error="$v.dataAdd_roleName.$error"
          v-model.trim.lazy="$v.dataAdd_roleName.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_roleName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_roleName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      dataAdd_roleId: "",
      dataAdd_roleName: "",
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_roleId: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    dataAdd_roleName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addRoleUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.role,
          new_role_id: this.dataAdd_roleId,
          new_role_name: this.dataAdd_roleName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;
 
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_roleId, this.dataAdd_roleName);
                  this.$refs.addRole.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  // this.$emit("failed", "add_role", this.feedback.status);
                  // this.$refs.addRole.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_roleId = "";
      this.dataAdd_roleName = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_roleId.$el.focus();
    }
  }
};
</script>
